export const VoyageFinalizedIndPolicy = ({
    F: "F",
    UF: "UF",
})